import React from 'react';
import './style.scss';

function Spinner({ size, color, borderWidth, margin }) {
    const ringColor = color || '#000';
    const border = borderWidth || 4;
    const spinSize = size || 57;
    const edging = margin || 0;
    return (
        <div className="spinner" style={{ width: `${spinSize}px`, height: `${spinSize}px`, borderWidth: `${edging}px` }}>
            <div
                className="ring"
                style={{
                    borderColor: `${ringColor} transparent ${ringColor} ${ringColor}`,
                    borderWidth: `${border}px`,
                }}
            />
        </div>
    );
}

export default Spinner;
export { Spinner };



// WEBPACK FOOTER //
// ./src/components/spinner/index.js